import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ListItem } from '../../../Model/model';

@Component({
  selector: 'app-nested-list-para-link',
  imports: [CommonModule],
  templateUrl: './nested-list-para-link.component.html',
  styleUrl: './nested-list-para-link.component.scss'
})
export class NestedListParaLinkComponent {

  @Input() items: ListItem[] = [];
  @Input() isParagraph: boolean = false;
  @Input() heading!:string;
 


  @Input() listType: string = 'ul';

  isOrdered(type: string): boolean {
    return ['1', 'a', 'A', 'i', 'I'].includes(type);
  }

  // getNormalizedType(type: string): string {
  //   return type || '1';
  // }

  trackByIndex(index: number): number {
    return index;
  }

  processText(text: string): string {
    return text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
  }

}
